<template>
	<div class="adivice-wrapper">
		<div class="reservation-wrapper">
			<div class=" flex-bt">
				<div class="left">
					<div class="title flex-start">
						<div class="logo-wrapper">
							<img src="@/assets/images/small-logo.png" alt="" />
						</div>
						<span>开店有疑难？</span>
					</div>
					<div class="big-title">找<span>专家</span>谈谈</div>
					<div class="tips">
						有任何关于开网店或电商难题，不妨预约谈谈， LOOPSHOP
						电商顾问会为你提供最适切的帮助。
					</div>
					<router-link to="/consultation">
						<div class="start" id="scrollButton">立即预约</div>
					</router-link>
				</div>
				<div class="right">
					<img src="@/assets/images/suitability3.png" alt="" />
				</div>
			</div>
		</div>
		<div class="reservation-grop-warpper" id="targetElement">
			<div class="reservation-flex">
				<div class="left">
					<img src="@/assets/images/advice1.png" alt="" />
				</div>
				<div class="right">
					<div class="reservation">
						<div>立即预约 <span>专人咨询</span></div>
					</div>
					<div class="form">

						<div class="form-group">
							<div class="label">您的名字</div>
							<input id="name" v-model="formData['nickname']" :class="{ error: showError == 'nickname' }"
								placeholder="您的名字" />
						</div>
						<div class="form-group">
							<div class="label">电话</div>
							<input id="phone" v-model="formData['mobile']" :class="{ error: showError == 'mobile' }"
								placeholder="您的电话" />
						</div>
						<!-- <div class="form-group">
							<div class="label">电话验证码</div>
							<div class="value">
								<input id="mobileCode" v-model="formData['mobileCode']"
									:class="{ error: showError && formData['mobileCode'] === '' }" placeholder="电话验证码" />
								<div class="code" @click="sendMobile()" :class="[mobileCode != '60' ? 'disabled' : '']">{{
									mobileCode == 60 ?
									'发送验证码' : `${mobileCode}S` }} </div>
							</div>
						</div> -->
						<div class="form-group">
							<div class="label">电邮</div>
							<input id="email" v-model="formData['email']" :class="{ error: showError == 'email' }"
								placeholder="您的电邮" />
						</div>
						<!-- <div class="form-group">
							<div class="label">电邮验证码</div>
							<div class="value">
								<input id="emailCode" v-model="formData['emailCode']"
									:class="{ error: showError && formData['emailCode'] === '' }" placeholder="电邮验证码" />
								<div class="code" :class="[emailCode != '60' ? 'disabled' : '']" @click="sendEmail()">{{
									emailCode == 60 ? '发送验证码'
									: `${emailCode}S`
								}} </div>
							</div>
						</div> -->
						<div class="form-group">
							<div class="label">您的网店</div>
							<input id="link" v-model="formData['faceig']" :class="{ error: showError == 'faceig' }"
								placeholder="您的网店或Facebook专页连结" />
						</div>
						<div class="pay-attention">
							* 填妥表格登记，即代表同意所提供之资料可供LOOPSHOP日后作营销用途。
						</div>
						<div @click="submitForm" class="button">提交</div>
					</div>
				</div>
			</div>
		</div>
		<SwiperContent></SwiperContent>
		<Start></Start>
		<el-dialog title="提示" top="20%" :show-close="false" :visible.sync="dialogVisible" width="30%">
			<span>{{ timer }}秒后将为你链接专属客服</span>
		</el-dialog>
	</div>
</template>
<script>

import Start from "@/components/Start.vue";
import SwiperContent from "@/components/SwiperContent.vue";
import { checkFormToast, rules } from 'lonjin-helper'
export default {
	components: { SwiperContent, Start },
	data() {
		return {
			webset: [],
			mobileCode: 60,
			emailCode: 60,
			timer: 3,
			timerFun: null,
			dialogVisible: false,
			showError: false,
			formData: {
				nickname: '',
				mobile: '',
				email: '',
				faceig: '',
				sjk: 'consultation'
			},

		};
	},

	mounted() {
		const scrollButton = document.getElementById('scrollButton');
		const targetElement = document.getElementById('targetElement');

		// 添加点击事件监听器
		scrollButton.addEventListener('click', () => {
			// 将目标元素滚动到可视区域内
			targetElement.scrollIntoView({ behavior: 'smooth' });
		});
	},
	created() {
		this.getSet()
	},
	methods: {

		sendMobile() {
			if (this.mobileCode < 60) return false
			const _this = this
			let timer = setInterval(() => {
				_this.mobileCode -= 1
				if (_this.mobileCode <= 0) {
					_this.mobileCode = 60
					clearInterval(timer)
				}
			}, 1000)
		},

		sendEmail() {
			if (this.emailCode < 60) return false
			const _this = this
			let timer = setInterval((val) => {
				_this.emailCode -= 1
				if (_this.emailCode <= 0) {
					_this.emailCode = 60
					clearInterval(timer)
				}
			}, 1000)
		},
		handleClose() {
			clearInterval(this.timerFun)
			this.dialogVisible = false
		},

		openTimer() {
			!this.dialogVisible && (this.dialogVisible = true)
			this.timerFun = setInterval(() => {
				if (this.timer == 1) {
					clearInterval(this.timerFun)
					this.dialogVisible = false
					let gourl = 'https://api.whatsapp.com/send?phone=' + this.webset.whatsapp + '&msg=' + this.webset.sayhi
					window.location.href = gourl
				} else {
					this.timer--
				}
			}, 1000);
		},

		async getSet() {
			console.log('go...');
			let fdata = { do: 'getSet', goto: 'webset' }
			let res = await this.$api.funk(fdata)
			this.webset = res
		},

		async submitForm() {
			this.showError = '';
			const mobileRules = (val, message) => {
				const reg = /^\d{8}$/;
				if (!reg.test(val)) return message
			}
			let nickname = rules.isEmpty(this.formData.nickname, '请输入您的名字')
			let mobile = rules.isEmpty(this.formData.mobile, '请输入电话')
			let isMobile = mobileRules(this.formData.mobile, '请输入8位电话号码')
			let email = rules.isEmpty(this.formData.email, '请输入电邮')
			let isEmail = rules.isEmail(this.formData.email, '请输入正确的电邮')
			let faceig = rules.isEmpty(this.formData.faceig, '请输入您的网店或Facebook专页连结')
			let message = checkFormToast(nickname, mobile, isMobile, email, isEmail, faceig)


			const MESSAGE_ENUM = {
				'请输入您的名字': 'nickname',
				'请输入电话': 'mobile',
				'请输入8位电话号码': 'mobile',
				'请输入电邮': 'email',
				'请输入正确的电邮': 'email',
			}

			if (message) {
				this.showError = MESSAGE_ENUM[message]
				this.$message.error(message)
			} else {
				// 执行报名逻辑
				console.log('报名成功');
				let res = await this.$api.register(this.formData)
				if (res.code == 1) {
					this.$message.success('OK');
					this.openTimer()

				} else {
					this.$message.error('error');
				}
			}
		},
	}
};
</script>
<style lang="scss" scoped>
.adivice-wrapper {
	.error {
		border: 1px solid red !important;
	}

	.reservation-wrapper {
		.left {
			padding-left: 3.2rem;

			.tips {
				text-align: left;
				font-family: "Microsoft YaHei";
				font-style: normal;
				font-weight: 400;
				font-size: 0.24rem;
				line-height: 0.34rem;
				color: #000000;
				width: 4rem;
			}

			.big-title {
				font-family: "Microsoft YaHei";
				font-style: normal;
				font-weight: 600;
				font-size: 0.56rem;
				line-height: 0.78rem;
				color: #000000;

				span {
					color: #e02e43;
				}
			}

			.start {
				width: 2.72rem;
				height: 0.8rem;
				background: #e02e43;
				border-radius: 0.08rem;
				margin-top: 0.8rem;
				cursor: pointer;
				text-align: center;
				font-family: "Microsoft YaHei";
				font-style: normal;
				font-weight: 600;
				font-size: 0.24rem;
				line-height: 0.8rem;
				color: #ffffff;
				letter-spacing: 1px;
			}

			.title {
				position: relative;

				.logo-wrapper {
					position: absolute;
					bottom: 0.4rem;
					left: -0.4rem;
					width: 0.78rem;
					height: 0.49rem;

					img {
						width: 100%;
						height: 100%;
						display: block;
					}
				}

				span {
					font-family: "Microsoft YaHei";
					font-style: normal;
					font-weight: 600;
					font-size: 0.57rem;
					line-height: 0.48rem;
					color: #000000;
				}

				.tag {
					width: 1.18rem;
					height: 0.54rem;
					background: #e02e43;
					border-radius: 0.04rem;
					text-align: center;
					font-family: "Microsoft YaHei";
					font-style: normal;
					font-weight: 600;
					font-size: 0.32rem;
					line-height: 0.54rem;
					color: #ffffff;
					margin-left: 0.08rem;
				}
			}
		}

		.right {
			width: 10.50rem;
			height: 8.8rem;

			img {
				width: 100%;
				height: 100%;
				display: block;
				object-fit: cover;
			}
		}
	}

	.reservation-grop-warpper {
		.reservation-flex {
			display: flex;

			.left {
				width: 8.70rem;
				height: 8.8rem;

				img {
					width: 100%;
					height: 100%;
					display: block;
					object-fit: cover;
				}
			}

			.right {
				padding-left: 1.1rem;

				.reservation {
					font-family: "Microsoft YaHei";
					font-style: normal;
					font-weight: 600;
					font-size: 0.4rem;
					line-height: 0.4rem;
					color: #000000;
					padding-top: 0.6rem;
					padding-bottom: 0.4rem;

					span {
						color: #e02e43;
					}
				}

				.form {
					.form-group {
						.label {
							font-family: "Microsoft YaHei";
							font-style: normal;
							font-weight: 400;
							font-size: 0.2rem;
							line-height: 0.28rem;
							color: #000000;
							margin-top: 0.16rem;
						}

						.value {
							width: 4.3rem;
							height: 0.56rem;
							background: #fafafa;
							border: 1px solid #999999;
							border-radius: 0.08rem;
							display: block;
							margin-top: 0.08rem;
							padding: 0 0.16rem;
							display: flex;
							justify-content: space-between;
							overflow: hidden;
							align-items: center;
							padding-right: 0;

							input {
								flex: 1;
								border: none;
								margin: 0;
								padding: 0;
							}

							.code {
								background: #e02e43;
								color: #fff;
								width: 1rem;
								height: 0.46rem;
								font-size: 12px;
								text-align: center;
								border-radius: 0.08rem;
								line-height: 0.46rem;
								cursor: pointer;
								margin-right: 0.04rem;

								&.disabled {
									background: #999999;
									cursor: not-allowed;
								}
							}
						}

						input {
							width: 4.3rem;
							height: 0.56rem;
							background: #fafafa;
							border: 1px solid #999999;
							border-radius: 0.08rem;
							display: block;
							margin-top: 0.08rem;
							padding: 0 0.16rem;
						}

						input::placeholder {
							font-family: "Nunito";
							font-style: normal;
							font-weight: 400;
							font-size: 0.16rem;
							line-height: 0.24rem;
							letter-spacing: 0.5px;
							color: #1c1b1f;
						}
					}

					.pay-attention {
						font-family: "Microsoft YaHei";
						font-style: normal;
						font-weight: 400;
						font-size: 0.12rem;
						line-height: 0.17rem;
						color: #000000;
						margin-top: 0.16rem;
					}

					.button {
						width: 2.08rem;
						font-family: "Microsoft YaHei";
						font-style: normal;
						font-weight: 600;
						font-size: 0.24rem;
						line-height: 0.32rem;
						color: #ffffff;
						padding: 0.16rem 0;
						text-align: center;
						background: #e02e43;
						border-radius: 0.08rem;
						margin-top: 0.4rem;
						cursor: pointer;
					}
				}
			}
		}

	}
}

@media (max-width: 750px) {
	.reservation-wrapper .flex-bt {
		display: block;
	}

	.adivice-wrapper .reservation-wrapper .left {
		padding: 1.6rem 0.4rem 0.8rem 0.8rem;
	}

	.adivice-wrapper .reservation-wrapper .left .tips {
		width: 100%;
		font-size: 0.28rem;
		line-height: 0.34rem;
	}

	.adivice-wrapper .reservation-wrapper .left .big-title {
		margin-top: 0.12rem;
	}

	.adivice-wrapper .reservation-wrapper .left .start {
		width: 3.72rem;
		height: 1.1rem;
		line-height: 1.1rem;
		border-radius: 0.1rem;
		font-size: 0.3rem;
	}

	.adivice-wrapper .reservation-wrapper .right {
		width: 100%;
	}

	.adivice-wrapper .reservation-grop-warpper .reservation-flex {
		display: block;
	}

	.reservation-grop-warpper {
		height: 20.8rem;
		position: relative;
	}

	.adivice-wrapper .reservation-grop-warpper .reservation-flex .left {
		width: 100%;
		position: absolute;
		top: 12rem;
		left: 0;
	}

	.adivice-wrapper .reservation-grop-warpper .reservation-flex .right {
		padding-left: 0.4rem;
		padding-right: 0.4rem;
	}

	.adivice-wrapper .reservation-grop-warpper .reservation-flex .right .reservation {
		font-size: 0.5rem;
		line-height: 0.5rem;
	}

	.adivice-wrapper .reservation-grop-warpper .reservation-flex .right .form .form-group .label {
		font-size: 0.32rem;
		margin-top: 0.32rem;
	}

	.adivice-wrapper .reservation-grop-warpper .reservation-flex .right .form .pay-attention {
		font-size: 0.2rem;
		line-height: 0.3rem;
	}

	.adivice-wrapper .reservation-grop-warpper .reservation-flex .right .form .form-group input {
		width: 100%;
		height: 0.9rem;
		margin-top: 0.12rem;
		font-size: 0.32rem;
	}

	.adivice-wrapper .reservation-grop-warpper .reservation-flex .right .form .button {
		width: 3.4rem;
		font-size: 0.32rem;
		line-height: 0.32rem;
		padding: 0.3rem 0;
		border-radius: 0.1rem;
	}
}
</style>